/* <detail-ingredients> — carrousel de saveurs (swipe) contenant un carrousel d'ingrédients (swipe).
   Modèle « carrousel dans le carrousel » :
   - Extérieur : scroll-snap horizontal entre saveurs (tactile natif + drag souris + flèches + vignettes + dots).
   - Intérieur : chaque saveur a son carrousel de cartes d'ingrédients (tactile natif + drag souris).
   - Met à jour --di-bg (bandeau couleur) et l'état actif (vignette/dot) selon la saveur visible (IntersectionObserver).
   - Aucune dépendance externe. Respecte prefers-reduced-motion. Garde-fous : aucun crash si un élément manque. */
(function () {
  if (customElements.get('detail-ingredients')) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Glissement horizontal animé « maison » (rAF).
     On n'utilise pas scrollTo({behavior:'smooth'}) : combiné à scroll-snap: x mandatory,
     il est ignoré par plusieurs moteurs (le scroll reste sur place). Ici on neutralise le
     snap le temps de l'animation, puis on le restaure pour que le doigt retrouve l'accroche. */
  function animateScrollTo(el, to, done, dur) {
    if (!el) return;
    if (el._diRaf) cancelAnimationFrame(el._diRaf);
    if (typeof dur !== 'number' || isNaN(dur)) dur = 0;
    var from = el.scrollLeft;
    var delta = to - from;
    // Durée nulle = saut immédiat. C'est le comportement par défaut : sur un clic de
    // sélection, faire défiler plusieurs écrans donne une impression de latence.
    if (reduce.matches || dur <= 0 || Math.abs(delta) < 2) {
      el.scrollLeft = to;
      if (done) done();
      return;
    }
    var t0 = null;
    el.classList.add('is-animating');           // CSS : scroll-snap-type: none

    function finish() {
      if (el._diRaf) { cancelAnimationFrame(el._diRaf); el._diRaf = null; }
      clearTimeout(el._diSafety);
      el._diSafety = null;
      el.scrollLeft = to;
      el.classList.remove('is-animating');
      if (done) done();
    }

    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var e = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;  // easeInOutCubic
      el.scrollLeft = from + delta * e;
      if (p < 1) {
        el._diRaf = requestAnimationFrame(step);
      } else {
        finish();
      }
    }

    el._diRaf = requestAnimationFrame(step);
    // Filet : en onglet masqué, rAF est gelé et l'animation ne démarre jamais.
    // On garantit alors la position finale (et donc un état cohérent au retour).
    clearTimeout(el._diSafety);
    el._diSafety = setTimeout(function () { if (el._diRaf) finish(); }, dur + 260);
  }

  // Drag souris pour faire défiler un rail horizontal. Le tactile/molette restent natifs.
  function enableDrag(track) {
    if (!track || track._diDrag) return;
    track._diDrag = true;
    var down = false, startX = 0, startScroll = 0, moved = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;   // tactile = scroll natif
      down = true; moved = 0;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      moved = Math.abs(dx);
      track.scrollLeft = startScroll - dx;
    });
    var end = function () {
      if (!down) return;
      down = false;
      track.classList.remove('is-dragging');
    };
    track.addEventListener('pointerup', end);
    track.addEventListener('pointerleave', end);
    track.addEventListener('pointercancel', end);
    // Empêche le clic-fantôme sur une carte après un vrai drag.
    track.addEventListener('click', function (e) {
      if (moved > 6) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    // Neutralise le drag natif des images.
    track.querySelectorAll('img').forEach(function (img) {
      img.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  customElements.define('detail-ingredients', class extends HTMLElement {
    connectedCallback() {
      // La couleur de saveur est posée le plus haut possible (wrapper de section
      // Shopify) pour que TOUT le fond change, padding de section compris — sinon
      // il reste deux bandes non colorées en haut et en bas. Les descendants
      // héritent de --di-bg.
      this.wrapper = this.closest('.shopify-section') || this.closest('.detail-ingredients') || this;
      this.viewport = this.querySelector('[data-di-viewport]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-di-slide]'));
      if (!this.viewport || !this.slides.length) return;

      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-di-tab]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-di-dot]'));
      this.index = 0;
      // Durée du glissement au clic (0 = saut immédiat), pilotée par le réglage.
      this.animMs = parseInt(this.getAttribute('data-anim-ms') || '0', 10) || 0;
      var self = this;

      // Flèches saveurs
      var prev = this.querySelector('[data-di-prev]');
      var next = this.querySelector('[data-di-next]');
      if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); });
      if (next) next.addEventListener('click', function () { self.go(self.index + 1); });

      // Vignettes + dots
      this.tabs.forEach(function (t) {
        t.addEventListener('click', function () { self.go(parseInt(t.getAttribute('data-di-tab'), 10)); });
      });
      this.dots.forEach(function (d) {
        d.addEventListener('click', function () { self.go(parseInt(d.getAttribute('data-di-dot'), 10)); });
      });

      // Drag souris sur le carrousel de saveurs (déclenché depuis la zone héro).
      enableDrag(this.viewport);

      // Carrousels d'ingrédients (un par saveur). Le drag des cartes ne doit pas glisser les saveurs.
      this.slides.forEach(function (slide) {
        var track = slide.querySelector('[data-di-cards]');
        if (!track) return;
        enableDrag(track);
        track.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
      });

      // Saveur visible → index actif (met à jour vignette/dot + couleur de fond).
      // Piloté par le scroll : fiable avec scroll-snap, et sans conflit avec go()
      // (qui pose un verrou le temps de l'animation).
      var raf = null;
      this.viewport.addEventListener('scroll', function () {
        if (self.lock) return;
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var w = self.viewport.clientWidth || 1;
          var i = Math.round(self.viewport.scrollLeft / w);
          self.setActive(Math.max(0, Math.min(self.slides.length - 1, i)));
        });
      }, { passive: true });

      this.setActive(0, true);
      this.preloadOtherFlavors();
    }

    /* Les images des saveurs non affichées sont en loading="lazy" : sans rien faire,
       elles ne se téléchargent qu'au moment du clic, d'où un temps de latence visible
       (surtout en connexion mobile). On les précharge une fois la page chargée et
       pendant un temps mort, pour ne pas concurrencer l'affichage initial. */
    preloadOtherFlavors() {
      var self = this;
      var run = function () {
        var imgs = Array.prototype.slice.call(self.querySelectorAll('img[loading="lazy"]'));
        imgs.forEach(function (img) {
          img.setAttribute('loading', 'eager');
          // Filet pour les moteurs qui ne relancent pas le chargement au changement
          // d'attribut : on met l'image en cache via une requête parallèle.
          if (!img.complete) {
            var pre = new Image();
            if (img.srcset) pre.srcset = img.srcset;
            if (img.sizes) pre.sizes = img.sizes;
            if (img.src) pre.src = img.src;
          }
        });
      };
      var schedule = function () {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(run, { timeout: 3000 });
        } else {
          setTimeout(run, 1500);
        }
      };
      if (document.readyState === 'complete') schedule();
      else window.addEventListener('load', schedule, { once: true });
    }

    go(i) {
      var n = this.slides.length;
      if (!n) return;
      var idx = ((i % n) + n) % n;
      var self = this;
      // Verrou : pendant l'animation, le handler de scroll ne recalcule pas l'index
      // (sinon les positions intermédiaires écrasent la cible).
      this.lock = true;
      var target = this.slides[idx];
      var left = target ? target.offsetLeft : this.viewport.clientWidth * idx;
      this.setActive(idx);
      animateScrollTo(this.viewport, left, function () { self.lock = false; }, this.animMs);
      // Garde-fou : si l'animation ne se termine pas (onglet masqué → rAF suspendu),
      // on relâche quand même le verrou pour ne pas figer la navigation au retour.
      clearTimeout(this._unlock);
      this._unlock = setTimeout(function () { self.lock = false; }, this.animMs + 400);
    }

    setActive(idx, force) {
      if (!force && idx === this.index) return;
      this.index = idx;
      // Marque la saveur affichée : le CSS s'en sert pour rejouer l'apparition
      // des cartes, seul repère visible quand deux saveurs débutent par les
      // mêmes ingrédients.
      this.slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      this.tabs.forEach(function (t, i) {
        var on = i === idx;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });

      var slide = this.slides[idx];
      var bg = slide && slide.getAttribute('data-bg');
      if (bg && this.wrapper) {
        if (reduce.matches) {
          var prevT = this.wrapper.style.transition;
          this.wrapper.style.transition = 'none';
          this.wrapper.style.setProperty('--di-bg', bg);
          void this.wrapper.offsetWidth;
          this.wrapper.style.transition = prevT;
        } else {
          this.wrapper.style.setProperty('--di-bg', bg);
        }
      }
    }
  });
})();
